module.exports = __webpack_public_path__ + "static/img/img_cat_raise_photo.365840f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_raise_photo.png
// module id = 553
// module chunks = 1